export const NAVBAR_ID = 'navbar';
